/**
 * Shared password-strength rules, used by both VerifyEmailPage.js (the
 * standard email-verified path) and SignUpPage.js's trusted-link instant
 * signup (see components/PasswordSetupFields.js for the shared UI).
 */

export const PASSWORD_REQUIREMENTS = [
  { label: 'At least 8 characters', test: (p) => p.length >= 8 },
  { label: 'One uppercase letter (A-Z)', test: (p) => /[A-Z]/.test(p) },
  { label: 'One lowercase letter (a-z)', test: (p) => /[a-z]/.test(p) },
  { label: 'One digit (0-9)', test: (p) => /\d/.test(p) },
  { label: 'One special character', test: (p) => /[@$!%*?&#^()_+\-=[\]{}|;:,.<>]/.test(p) },
];

export function passwordStrengthScore(password) {
  return PASSWORD_REQUIREMENTS.filter((req) => req.test(password)).length;
}

export function passwordsMatch(password, confirmPassword) {
  return password === confirmPassword && confirmPassword.length > 0;
}

export function allPasswordRequirementsMet(password) {
  return passwordStrengthScore(password) === PASSWORD_REQUIREMENTS.length;
}
